export enum SocialShareButtonsTestIds {
    HOST = 'SocialShareButtons',
    FACEBOOK_SHARE = 'SocialShareButtons__facebook-share',
    TWITTER_SHARE = 'SocialShareButtons__twitter-share',
    FACEBOOK_ICON = 'SocialShareButtons__facebook-icon',
    TWITTER_ICON = 'SocialShareButtons__twitter-icon',
}

export enum SocialShareButtonsAltText {
    FACEBOOK_ICON = 'Share to Facebook',
    TWITTER_ICON = 'Tweet Article',
}
